import React, { ReactElement } from 'react';

export default function Tick(props: {
    className?: string;
}): ReactElement {
    const { className } = props;

    return (
        <svg className={className} fill='none' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'>
            <path d='M9.5501 18L4.5572 13.0071C4.16668 12.6166 4.17207 11.978 4.5626 11.5875C4.95312 11.197 5.59168 11.1916 5.9822 11.5821L9.5501 15.15L18.018 6.68208C18.4085 6.29156 19.0471 6.29695 19.4376 6.68748C19.8281 7.078 19.8335 7.71656 19.443 8.10708L9.5501 18Z' fill='currentColor' />
        </svg>
    );
}

